<template>
    <div class="wrapper">
        <admin-title :title="$route.meta.name"></admin-title>
        <div class="header-search">
            <el-form ref="form" inline :model="searchData" label-width="">
                <el-form-item label="名称">
                    <el-input style="width: 200px" clearable v-model="searchData.name" size="mini"
                              placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button type="primary" size="mini" icon="el-icon-search" @click="getList">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-refresh" @click="reset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-button style="margin-bottom: 10px" type="primary"
                   icon="el-icon-plus"
                   size="mini"
                   plain
                   @click="dialogVisible = true"
        >新增
        </el-button>
        <el-table :data="list">
            <el-table-column prop="id" label="ID" min-width="120"></el-table-column>
            <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
            <el-table-column prop="commission_rate" label="抽佣比例" min-width="120"></el-table-column>
            <el-table-column prop="row" label="管理人" min-width="120">
                <template slot-scope="{ row }">
                    <span>{{ row.manage_agent_user.id }} | </span>
                    <span>{{ row.manage_agent_user.account }} | </span>
                    <span><el-tag type="small">{{ row.manage_agent_user.status_dsc }}</el-tag></span>
                </template>
            </el-table-column>
            <el-table-column prop="employee_count" label="员工人数" min-width="120"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120"></el-table-column>
            <el-table-column label="操作" width="140" fixed="right">
                <template slot-scope="{ row }">
                    <el-link style="margin-right: 10px" type="primary" :underline="false" @click="handleDetail(row)">详情</el-link>
                    <el-link style="margin-right: 10px" type="primary" :underline="false" @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link :underline="false" type="danger" @click="handleDel(row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchData.page" :limit.sync="searchData.pagesize"
                    @pagination="getList"/>

        <add-or-edit
            v-if="dialogVisible"
            :dialog-visible="dialogVisible"
            :id="currentId"
            @close-form="handleClose"
            @modify-success="modifySuccess"
        >
        </add-or-edit>

        <!--详情-->
        <Detail ref="detail"></Detail>
    </div>
</template>

<script>
import {listAPI, delAPI} from './api'
import addOrEdit from "./component/addOrEdit.vue";
import Detail from "@/views/agent/agent/detail.vue";

export default {
    name: 'items',
    components: {addOrEdit, Detail},
    data() {
        return {
            dialogVisible: false,
            total: 0,
            currentId: 0,
            searchData: {
                page: 1,
                pagesize: 10,
                name: ''
            },
            list: []
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        async getList() {
            const res = await listAPI(this.searchData)
            this.list = res.data || []
            this.total = res.total || 0
        },

        handleEdit(row) {
            this.currentId = row.id
            this.dialogVisible = true
        },

        handleDetail({id}) {
            this.$refs.detail.open(id)
        },

        async handleDel({id}) {
            this.$confirm('确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    delAPI({id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
                .catch(() => {
                    this.$message.info('取消删除')
                })
        },

        handleClose() {
            this.dialogVisible = false
            this.currentId = 0
        },

        modifySuccess() {
            this.dialogVisible = false
            this.currentId = 0
            this.getList()
        },

        reset() {
            Object.assign(this._data.searchData, this.$options.data().searchData)
            this.getList()
        }
    }
}
</script>


<style scoped lang="scss">

</style>
